/* eslint-disable react/prop-types */
import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend,
  defaults
} from 'chart.js'
import { Line } from 'react-chartjs-2'

defaults.font.family = 'JetBrains Mono'

const pluginImage = {
  id: 'customImage',
  beforeDraw: (chart) => {
    const image = chart.config._config.options.img_decidechile

    const {
      ctx
    } = chart

    ctx.save()
    ctx.globalAlpha = 0.6
    if (image.complete) {
      const ctx = chart.ctx
      const {
        top,
        left
      } = chart.chartArea
      let imageWidth = 0.2 * image.naturalWidth
      let imageHeight = 0.2 * image.naturalHeight
      let offsetX = 200
      let offsetY = 150
      if (chart.width < 800) {
        imageWidth = 0.7 * imageWidth
        imageHeight = 0.7 * imageHeight
        offsetX = 150
        offsetY = 50
      }

      const x = left - imageWidth + offsetX
      const y = top - imageHeight + offsetY

      ctx.drawImage(image, x, y, imageWidth, imageHeight)
    } else {
      image.onload = () => chart.draw()
    }
    ctx.restore()
  }
}

const testPlugin = {
  id: 'customPlugin',
  afterDraw: chart => {
    const datasets = chart.config.data.datasets
    if (datasets) {
      const ctx = chart.ctx

      ctx.save()
      ctx.fillStyle = 'black'
      for (let i = 0; i < datasets.length; i++) {
        const ds = datasets[i]
        const meta = chart.getDatasetMeta(i)

        let offsetYExtra = 0
        const len = meta.data.length - 1
        if (i === 2) {
          const valueApruebo = datasets[2].data.at(len).y.toFixed(2)
          const valueRechazo = datasets[3].data.at(len).y.toFixed(2)
          if (valueApruebo > valueRechazo) {
            if (chart.width < 800) {
              offsetYExtra = -5
            } else {
              offsetYExtra = -15
            }
          } else {
            if (chart.width < 800) {
              offsetYExtra = 5
            } else {
              offsetYExtra = 15
            }
          }
        }
        const xOffset = meta.data.at(len).x + 5
        const yOffset = meta.data.at(len).y + offsetYExtra
        const value = ds.data.at(len).y.toFixed(2)
        const text = `${value}%`
        ctx.font = '400 14px JetBrains Mono'
        if (chart.width < 800) {
          ctx.font = '400 8px JetBrains Mono'
        }
        ctx.lineWidth = 3
        ctx.strokeStyle = 'white'
        ctx.strokeText(text, xOffset, yOffset)
        ctx.fillStyle = 'black'
        ctx.fillText(text, xOffset, yOffset)
      }
      ctx.restore()
    }
  }
}

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  pluginImage,
  testPlugin
)

export function MediosChart ({ chartData, options }) {
  return (
      <div className = "chart-container">
        <Line options={options} data={chartData} id = "mediosChart"/>
      </div>)
}
